module.exports = __webpack_public_path__ + "public/Icons/manage_admins.svg?00429368";